import './App.css';
import UrmSimulatorPage from "./pages/UnlimitedRegisterMachine/UrmSimulatorPage";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import HomePage from "./pages/HomePage";
import NoPage from "./pages/NoPage";
import TmSimulatorPage from "./pages/TuringMachine/TmSimulatorPage";

function App() {
  return (
    <div className="App">
        <BrowserRouter>
            <Routes>
                <Route path="/">
                    <Route index element={<HomePage />} />
                    <Route path="urm" element={<UrmSimulatorPage />} />
                    <Route path="tm" element={<TmSimulatorPage />} />
                    <Route path="*" element={<NoPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
